import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2 } from 'lucide-react';
export function AccessPage() {
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const handleAccess = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!code.trim()) return;
    setIsLoading(true);
    setError(false);
    // Simulate network request
    await new Promise(resolve => setTimeout(resolve, 800));
    if (code.trim().toUpperCase() === 'BETIQ2026') {
      window.location.href = 'https://betiqpro.apuestasinteligentes.com';
    } else {
      setError(true);
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center p-6 selection:bg-blue-500/30" data-id="element-9">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="w-full max-w-sm mx-auto" data-id="element-10">
        <div className="text-center mb-10" data-id="element-11">
          <h1 className="text-3xl font-bold text-white mb-2 tracking-tight" data-id="element-12">
            Access BetIQ
          </h1>
          <p className="text-sm text-zinc-400" data-id="element-13">
            Enter your access code to continue
          </p>
        </div>

        <form onSubmit={handleAccess} className="space-y-6" data-id="element-14">
          <div className="relative" data-id="element-15">
            <motion.div animate={error ? {
            x: [-8, 8, -8, 8, 0]
          } : {}} transition={{
            duration: 0.4
          }} data-id="element-16">
              <input type="text" value={code} onChange={e => {
              setCode(e.target.value);
              if (error) setError(false);
            }} placeholder="Enter your access code" className={`w-full bg-zinc-900/50 border ${error ? 'border-red-500/50 focus:border-red-500/50 focus:ring-red-500/20' : 'border-zinc-800 focus:border-blue-500/50 focus:ring-blue-500/20'} rounded-xl px-4 py-3.5 text-white placeholder:text-zinc-600 outline-none transition-all focus:ring-4 text-center tracking-widest uppercase`} autoComplete="off" autoCorrect="off" spellCheck="false" data-id="element-17" />
            </motion.div>

            <div className="h-6 mt-2" data-id="element-18">
              <AnimatePresence data-id="element-19">
                {error && <motion.p initial={{
                opacity: 0,
                y: -5
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -5
              }} className="text-red-400 text-xs text-center" data-id="element-20">
                    Invalid code. Please check and try again.
                  </motion.p>}
              </AnimatePresence>
            </div>
          </div>

          <div data-id="element-21">
            <button type="submit" disabled={isLoading || !code.trim()} className="relative w-full group overflow-hidden rounded-xl bg-blue-600 px-4 py-3.5 text-sm font-semibold text-white transition-all hover:bg-blue-500 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 shadow-[0_0_20px_rgba(37,99,235,0.15)] hover:shadow-[0_0_25px_rgba(37,99,235,0.3)]" data-id="element-22">
              {isLoading ? <Loader2 className="animate-spin mx-auto w-5 h-5" data-id="element-23" /> : 'Access Now'}
            </button>
          </div>
        </form>

        <p className="text-xs text-zinc-600 mt-8 text-center font-medium" data-id="element-24">
          Exclusive access for verified users only
        </p>
      </motion.div>
    </div>;
}